// Mega Menu – Fix disappearing on scroll (Mouse Enter/Leave)
document.addEventListener('DOMContentLoaded', function () {
  const megaMenuItems = document.querySelectorAll('.has-megamenu');

  megaMenuItems.forEach(item => {
    // Mouse enter → open mega menu
    item.addEventListener('mouseenter', function () {
      this.classList.add('megamenu-open');
    });

    // Mouse leave → close mega menu
    item.addEventListener('mouseleave', function () {
      this.classList.remove('megamenu-open');
    });
  });
});